import { Validate } from '../global/_formValidation';

export const updateQty = () => {
	var timer = 0;
	$('.newQty').on('input', function (e) {
		var thisInput = e.target;
		$(thisInput).val(Validate.stripAllButNumerics($(this).val()).replace('.', ''));
		if ($(thisInput).val() != '' && $(thisInput).val() != '00' && e.key != 'Backspace') {
			clearTimeout(timer);
			timer = setTimeout(function () {
				if ($(thisInput).val() != '') {
					let index = $(thisInput).attr('name').split('_')[1];
					setDetails(index, $(thisInput).val());
					$(thisInput).attr('disabled', 'disabled');
				}
			}, 2000);
		}
	});
};

const setDetails = (index, newQty) => {
	if (typeof(Storage) !== 'undefined') {
		var tVal = decodeURIComponent(localStorage.getItem('tVal'));
		var input = document.createElement('input');
		input.type = 'hidden';
		input.name = 'tVal';
		input.value = tVal;
		$('form#SingleItemUpdateForm').append(input);
	} 		 
		 
	let itemType = $('.cartItem_' + index).parents('.table')[0].id;

	$("#SingleItemUpdateForm input[name='quantity_1']").val(newQty);
	$("#SingleItemUpdateForm input[name='catEntryId_1']").val($("input[name='catEntryId_" + index + "']").val());
	$("#SingleItemUpdateForm input[name='orderItemId_1']").val($("#ShopCartForm input[name='orderItemId_" + index + "']").val());
	$("#SingleItemUpdateForm input[name='quantitySelect_1']").val($("#ShopCartForm input[name='quantitySelect_" + index + "']").val());
	$("#SingleItemUpdateForm input[name='tieShipCode_1']").val($("#ShopCartForm select[name='tieShipCode_" + index + "']").val());
	$("#SingleItemUpdateForm input[name='itemType']").val(itemType);

	if (itemType.indexOf('registry-bag') == -1) {
		$("#SingleItemUpdateForm input[name='originalQuantity_1']").val($("#ShopCartForm input[name='originalQuantity_" + index + "']").val());
	} else {
		$("#SingleItemUpdateForm input[name='originalQuantity_1']").remove();
	}

	$('#SingleItemUpdateForm').submit();
};
